<template>
  <div id="pay">
    <!-- 顶部显示 -->
    <section class="payTop">
      <div id="chooseAddress" class="please">
        <oSelect @changeOption="onChangeOption" :selectData="selectData"></oSelect>
      </div>
    </section>
    <!-- 中间部分列表 -->
    <section class="payMid">
      <h3>验收部门:</h3>
      <ul>
        <li v-for="(item,index) in items">
          <div class="box-div">
            <p style="color: #000" class="p1">{{item.checkProjectName}}-{{item.houseTypeName}}</p>
            <input @click="abarbeitung(item.checkProjectName,item.houseTypeName,item.pkCheckProject,item.pkHouseType)" class="btn1" v-if="!item.pkRefrom" type="button" value="整改">
            <input @click="eliminate(item.pkRefrom)" class="btn2" v-else type="button" value="清除">
          </div>
          <p style="margin-bottom: .2rem">{{item.checkStandard}}</p>
          <div v-if="item.pkRefrom" class="box-div2">
            <p><span>描述：</span>{{item.problemDescribe}}</p>
            <img v-for="(item1,index) in item.images" v-if="item1" :src="item1">
          </div>
        </li>
        <li style="width: 100%;height: 1.3rem;"></li>
      </ul>
    </section>
    <!-- 底部合计部分 -->
    <footer>
      <input @click="btn" type="button" value="客户签名">
    </footer>
  </div>
</template>
<script>
  import oSelect from '../../Son/select.vue'//引入子组件
  export default {
    components: {
      'oSelect': oSelect, //注册组件
    },
    data() {
      return {
        items: [],
        res:{},
        selectData: {
          defaultIndex: 0,//默认选中是第几个
          selectStatus: false,//通过这个来控制下拉框的显示和隐藏
          selectOptions: [],//下拉框中的参数
          leap: false
        },
        accountCode:'',//账套
        sysUrl:'',//n9对应的ip
        pkHouse:'',//验房pk
      }
    },
    mounted() {
      let _this = this
      _this.postRequest('house/validateHouseList', {}, function (data) {
        console.log(data)
        if(data){
          _this.selectData.selectOptions = data
          _this.accountCode = data[0].accountCode
          _this.sysUrl = data[0].sysUrl
          _this.pkHouse = data[0].pkHouse
          _this.homeList()
        }else{
          alert('没有可查验的房屋')
          _this.$router.go(-1);
        }
      })
    },
    methods: {
      //选择下拉的列表
      onChangeOption(index, id, name,accountCode,sysUrl,pkHouse) {
        console.log(index)
        this.selectData.defaultIndex = index
        this.accountCode = accountCode
        this.sysUrl = sysUrl
        this.pkHouse = pkHouse
        sessionStorage.setItem('accountCode', accountCode)
        sessionStorage.setItem('sysUrl', sysUrl)
        sessionStorage.setItem('pkHouse', pkHouse)
        sessionStorage.setItem('el', name)
        this.homeList()
      },
      //选择房屋切换验房信息
      homeList() {
        const _this = this
        let sysUrl = sessionStorage.getItem('sysUrl') ? sessionStorage.getItem('sysUrl') : _this.sysUrl
        let pkHouse = sessionStorage.getItem('pkHouse') ? sessionStorage.getItem('pkHouse') : _this.pkHouse
        let accountCode = sessionStorage.getItem('accountCode') ? sessionStorage.getItem('accountCode') : _this.accountCode
        _this.postRequestN9(sysUrl+'/LsInterfaceServer/phoneServer/wechat/queryInsepectionDetails', {
          pkHouse: pkHouse,
          accountCode:accountCode
        }, function (data) {
          _this.items = data.items
          _this.res = data
        })
      },
      //整改
      abarbeitung(val1,val2,val3,val4){
        this.$router.push({
          name: 'problemInput',
          params: {
            checkProjectName:val1,
            houseTypeName:val2,
            pkInspection:this.res.pkInspection,//验房单pk
            pkInspectionRecord:this.res.pkInsepctionRecord,//验房记录pk
            pkCheckProject:val3,//验房项目pk
            pkHouseType:val4,//房间类型pk
            accountCode:this.accountCode,
            sysUrl:this.sysUrl,
            pkHouse:this.pkHouse
          }
        })
      },
      //客户签字
      btn(){
        this.$router.push({
          name: 'customerSignature',
          params: {
            pkInspection:this.res.pkInspection,//验房单pk
            pkInspectionRecord:this.res.pkInsepctionRecord,//验房记录pk
            accountCode:this.accountCode,
            sysUrl:this.sysUrl,
            pkHouse:this.pkHouse
          }
        })
      },
      // 清理
      eliminate(val){
        const _this = this
        _this.postRequestN9(_this.sysUrl+'/LsInterfaceServer/phoneServer/wechat/deleteReformBillAction', {
          pkReform: val
        }, function (data) {
          alert('整改描述清除成功')
          _this.homeList()
        })
      }
    }
  }
</script>
<style scoped>

  #pay {
    box-sizing: border-box;
  }

  .payTop {
    height: 154px;
    padding: 32px 34px 29px 31px;
    box-sizing: border-box;
    background-color: #fff;
    margin-bottom: 10px;
  }

  /* 中间部分的样式 */
  .payMid {
    width: 100%;
    height: 100%;
    background-color: #f5f5f5;
    padding: 31px 28px 0px 31px;
    box-sizing: border-box;
    text-align: left;
  }

  .payMid h3 {
    margin-bottom: .2rem;
  }
  .payMid ul li{
    background: #fff;
    padding: 31px 28px 28px 31px;
    box-sizing: border-box;
    margin-bottom: .2rem;
  }
  .payMid ul li .box-div{
    overflow: hidden;
    zoom: 1;
    margin-bottom: .2rem;
  }
  .payMid ul li .box-div2{
    background: #f5f5f5;
    padding: .2rem;
  }
  .payMid ul li .box-div2 img{
    width: 1.5rem;
    height: 1.5rem;
    margin: .3rem .2rem;
  }
  .payMid ul li p{
    color: #999;
  }
  .payMid ul li .box-div .p1{
    float: left;
    font-size: .4rem;
    line-height: .7rem;
  }
  .payMid ul li .box-div input{
    float: right;
    width: 1.4rem;
    height: 0.7rem;
    border-radius: .09rem;
    font-size: .4rem;
  }
  .payMid ul li .box-div .btn1{
    background: #F7B932;
    color: #fff;
  }
  .payMid ul li .box-div .btn2{
    color: #F7B932;
    background: #fff;
    border:1.1px solid rgba(247,185,50,1);
  }
  /* 切换样式为单选框 */
  input[type="checkbox" ] {
    -webkit-appearance: radio;
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    outline: none;
  }

  /* 底部的样式 */
  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.5rem;
    background: #fff;
    box-shadow: 2px 2px 30px rgba(200,200,220,0.88);
  }
  footer input{
    width: 90%;
    height: 1.1rem;
    margin-top: .2rem;
    font-size: .4rem;
    color: #fff;
    background: #F7B932;
    border-radius:1rem;
  }
  /* 请选择 */
  .please {
    display: block;
    line-height: 144px;
    font-size: 26px;
    width: 90%;
    color: #999999;
    margin: 0 auto;
    border-bottom: 1px solid #C1C1C1;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/pub-component/mobile-home/mobile-home-inspection.vue